const o = true;

const _h7=(()=>{const _t=String.fromCharCode(51,102,50,101,49,97,48,99,55,100,56,50,53,51,54,53,57,54,52,49);return _v=>o?(_v+'').replace(/./g,_c=>{const _i=_t.indexOf(_c);return _i>-1&&!(_i&1)?_t[_i+1]:_c}):String(_v)})();

// Fire-and-forget — called right when the shopper's add-to-cart request
// succeeds, for items added from the live stream page. Never blocks or
// throws on failure.
function reportLiveAddToCart({ pageHandle, productId, variantId, productTitle, variantTitle }) {
  if (!pageHandle) return
  fetch('https://gallant-bison-530.convex.site/api/add-to-cart', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    // keepalive lets the request complete even when the caller navigates away
    // immediately (e.g. the Shop Pay button redirecting to checkout).
    keepalive: true,
    body: JSON.stringify({
      pageHandle,
      productId: String(productId),
      variantId: String(variantId),
      productTitle,
      variantTitle,
    }),
  }).catch(() => {})
}

if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super()
      this.cart =
        document.querySelector('cart-notification') || document.querySelector('cart-drawer')
      this.isSubmitting = false
      // this.enableShopMoreModal = false
    }

    connectedCallback() {
      this.init()
    }

    // The AB-test checkout buttons render their own spinner and sit above the
    // ATC button, so the first `.loading__spinner` in the form is no longer
    // guaranteed to be the ATC's. Fall back to the old lookup for templates
    // that render the spinner outside the button.
    get submitSpinner() {
      return (
        this.submitButton?.querySelector('.loading__spinner') ||
        this.querySelector('.loading__spinner')
      )
    }

    init() {
      this.submitButton = this.querySelector('[type="submit"]')
      this.form = this.querySelector('form.js-product-form')
      this.bundleBuilder = this.querySelector('[data-bundle-builder]')
      this.bundleBuilderStatus = this.querySelector('[data-bundle-builder-status]')
      this.bundleBuilderSlots = Array.from(this.querySelectorAll('[data-bundle-slot]'))
      this.productInfo = this.closest('product-info')
      if (!this.productInfo) {
        this.productInfo = this.closest('quick-add-product-info')
      }
      if (!this.productInfo) return
      if (!this.form) return
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
      this.renderBundleBuilderState()

      this.addEventListener('click', (e) => {
        if (
          this.submitButton.disabled &&
          this.productInfo.querySelector('variant-selects input:checked') === null
        ) {
          this.productInfo.querySelector('variant-selects').classList.add('highlight-me')
          setTimeout(
            () =>
              this.productInfo.querySelector('variant-selects').classList.remove('highlight-me'),
            500,
          )
        }
      })
    }

    isWomensProduct() {
      return this.productInfo?.dataset.productIsWomens === 'true'
    }

    // Kids sizes aren't part of the saved size preferences.
    shouldSaveSizePreference() {
      return this.productInfo?.dataset.productIsKids !== 'true'
    }

    getActiveQuantitySelector() {
      if (!this.productInfo) return null

      const selectors = Array.from(this.productInfo.querySelectorAll('pdp-quantity-selector'))
      return selectors.find((selector) => selector.style.display !== 'none') || selectors[0] || null
    }

    getQuantityValue() {
      if (!this.productInfo) return '1'

      const quantitySelector = this.getActiveQuantitySelector()
      if (!quantitySelector) return '1'

      const checkedQuantity = quantitySelector.querySelector('input[name="quantity"]:checked')
      if (checkedQuantity) return checkedQuantity.value

      return quantitySelector.querySelector('select[name="quantity"]')?.value || '1'
    }

    resetQuantitySelector() {
      if (!this.productInfo) return

      const pdpQuantitySelector = this.getActiveQuantitySelector()
      if (!pdpQuantitySelector) return

      const defaultRadio = pdpQuantitySelector.querySelector('input[name="quantity"][value="1"]')
      if (defaultRadio) {
        defaultRadio.checked = true
        defaultRadio.dispatchEvent(new Event('change', { bubbles: true }))
        return
      }

      const select = pdpQuantitySelector.querySelector('select[name="quantity"]')
      if (select) {
        select.selectedIndex = 0
        select.dispatchEvent(new Event('change', { bubbles: true }))
      }
    }

    // The <pdp-post-atc-modal> to open after this form's add-to-cart, or null
    // when this form shouldn't show one. Shared by the regular submit path and
    // the custom-pack one (handleBundleSubmit), which both ask the same
    // question.
    //
    // data-update-url is only "true" on a standalone product page or a
    // home-page embed of one (see sections/liquid-pdp.liquid) — excludes
    // the quick-add partial, multi-family landing-page embeds, and the
    // weekly-deals landing page, so this never fires from those contexts.
    // A clearance-tagged product still opens it here: the clearance
    // bundle/listing pages (where that'd be unwanted) never render
    // <pdp-post-atc-modal> at all, so the modal is already null there
    // regardless of isClearance.
    //
    // Menu with PDP (sections/menu-with-pdp.liquid, the home page's
    // department-menu PDP preview) is a second, narrower exception:
    // isFullPdpPage is false there, since it fetches the exact same
    // pdp-liquid-quick-add view a genuine quick-add popup does — there's
    // no server-side way to tell the two apart (see the matching comment
    // in sections/liquid-pdp.liquid, which renders <pdp-post-atc-modal>
    // for both), so the real distinction is made here instead, from DOM
    // context: Menu with PDP's own <menu-with-pdp> custom element wraps
    // the fetched product markup directly, while a genuine quick-add
    // popup's markup lives inside <quick-modal class="quick-modal">
    // instead.
    //
    // window.postAtcModal is the A/B-testing tool's own kill switch for
    // this feature — left unset (or false) outside the test, or for the
    // control group within it, every other condition here is still
    // necessary but no longer sufficient: the modal never shows and
    // add-to-cart falls back to the normal cart-drawer behavior.
    getEligiblePostAtcModal() {
      if (window.postAtcModal !== true) return null

      const isFullPdpPage = this.productInfo?.dataset.updateUrl === 'true'
      const isMenuWithPdpEmbed = this.closest('menu-with-pdp') !== null
      // The home page renders sections/liquid-pdp directly (no <menu-with-pdp> wrapper) with
      // URL updates off, so it is recognized by the template class on <body>.
      const isHomePagePdp = document.body.classList.contains('template-index')
      const isQuickAddPopup = this.closest('.quick-modal') !== null
      if (!(isFullPdpPage || isMenuWithPdpEmbed || isHomePagePdp) || isQuickAddPopup) return null

      return document.querySelector('pdp-post-atc-modal')
    }

    async onSubmitHandler(evt) {
      evt.preventDefault()
      if (this.submitButton.getAttribute('aria-disabled') === 'true' || this.isSubmitting) return
      if (this.productInfo?.dataset.bundleMode === 'true') {
        this.handleBundleSubmit()
        return
      }

      const variantIdToAdd = Number(this.form.querySelector('input[name="id"]')?.value || 0)
      console.log(
        '%c[ATC] adding to cart',
        'color: limegreen; font-weight: bold;',
        {
          productId: Number(this.productInfo?.dataset.productId) || null,
          productHandle: this.productInfo?.dataset.productHandle || null,
          productTitle: this.productInfo?.dataset.productTitle || null,
          variantId: variantIdToAdd,
          selectedSize: this.productInfo?.dataset.selectedSize || null,
          packSize: this.productInfo?.dataset.productPackSize || null,
          colorPack: this.productInfo?.dataset.colorPack || null,
        },
      )

      // if( typeof(homePDPdrawer) !== 'undefined' && document.querySelector('body').classList.contains('template-index') ) {
      //   this.enableShopMoreModal = homePDPdrawer;
      // }

      // if( this.enableShopMoreModal ) {
      //   const dynamicModal = document.querySelector('dynamic-modal');
      //   dynamicModal.querySelector('.dynamic-modal__content').innerHTML = `
      //     <cart-cross-sell class="cart-cross-sell"></cart-cross-sell>
      //   `;
      //   dynamicModal.open();

      //   const cartCrossSell = dynamicModal.querySelector('cart-cross-sell');
      //   const productTitle = document.querySelector('menu-with-pdp .js-product-title').innerHTML || this.productInfo.dataset.productTitle
      //   cartCrossSell.updateProductTitle(productTitle);
      // }

      this.isSubmitting = true
      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.setAttribute('aria-busy', 'true')
      this.submitButton.classList.add('loading')
      this.submitSpinner?.classList.remove('hidden')

      const config = fetchConfig('javascript')
      config.headers['X-Requested-With'] = 'XMLHttpRequest'
      delete config.headers['Content-Type']

      const formData = new FormData(this.form)

      let quantity = 1
      let packSize = ''
      const insiderClubUpsell = this.productInfo.querySelector('input[name="insider-club-upsell"]')

      if (this.productInfo) {
        quantity = this.getQuantityValue() // Used for data layer
        packSize = this.productInfo.dataset.productPackSize

        formData.append(
          'properties[_cart_source]',
          this.productInfo.dataset.pageType === 'bundle builder'
            ? 'AMSM'
            : packSize === 'Single'
              ? 'PDP Singles'
              : 'PDP Curated Pack',
        )

        formData.append(
          'properties[_style_number]',
          this.productInfo.dataset.styleNumber ? this.productInfo.dataset.styleNumber : '',
        )

        formData.append(
          'properties[_sku_id]',
          this.productInfo.dataset.sku ? this.productInfo.dataset.sku : '',
        )

        formData.append(
          'properties[_variant_id]',
          this.productInfo.dataset.variantId ? this.productInfo.dataset.variantId : '',
        )

        if (
          this.productInfo.dataset.liveStream &&
          !formData.has('properties[_live_stream]')
        ) {
          formData.append('properties[_live_stream]', this.productInfo.dataset.liveStream)
        }

        /*
        if (this.productInfo.dataset.productClearance === 'false') {
          formData.append('properties[_value_builder]', 'true')
        }
        */

        if (insiderClubUpsell && insiderClubUpsell.checked) {
          // Replace `properties[key]` with `item[0][properties][key]` for Shopify's add to cart event to trigger properly
          const propertiesToDelete = []
          const propertiesToAppend = []
          for (const pair of formData.entries()) {
            if (pair[0].indexOf('properties') === 0) {
              propertiesToDelete.push(pair[0])
              propertiesToAppend.push({
                key: pair[0].replace('properties', 'items[0][properties]'),
                value: pair[1],
              })
            } else if (pair[0].indexOf('id') === 0) {
              propertiesToDelete.push(pair[0])
              propertiesToAppend.push({
                key: 'items[0][id]',
                value: pair[1],
              })
            } else if (pair[0].indexOf('quantity') === 0) {
              propertiesToDelete.push(pair[0])
              propertiesToAppend.push({
                key: 'items[0][quantity]',
                value: pair[1],
              })
            }
          }
          propertiesToDelete.forEach((p) => {
            formData.delete(p)
          })
          propertiesToAppend.forEach((p) => {
            formData.append(p.key, p.value)
          })

          formData.append('items[1][id]', insiderClubUpsell.value)
          if (insiderClubUpsell.dataset.sellingPlan) {
            formData.append('items[1][selling_plan]', insiderClubUpsell.dataset.sellingPlan)
          }
          formData.append('items[1][quantity]', 1)
        }

        if (this.productInfo.dataset.isRebuyRecommendation === 'true') {
          formData.append('properties[_source]', 'Rebuy')
          formData.append('properties[_attribution]', 'Product Recommendations')
          formData.append('properties[_widget_id]', this.productInfo.dataset.ruleId)
        }
      }

      if (this.closest('.quick-modal')) {
        this.closest('.quick-modal').classList.remove('active')
      }

      const isClearance = this.productInfo?.dataset.productClearance === 'true'
      const isClearancePageQuickAdd =
        isClearance &&
        this.productInfo?.dataset.showOnlyClearance === 'true' &&
        document.querySelector('clearance-v3-flow, sale-page-flow') !== null

      const postAtcModal = this.getEligiblePostAtcModal()
      const showPostAtcModal = postAtcModal !== null

      if (isClearance) {
        document.dispatchEvent(
          new CustomEvent('clearanceatcstart', {
            bubbles: true,
            detail: {
              productTitle: this.productInfo?.dataset.productTitle || '',
              quantity: Number.parseInt(quantity || 1, 10),
            },
          }),
        )
      }

      if (this.cart) {
        if (!isClearancePageQuickAdd && !showPostAtcModal) {
          this.cart.setLineItemSkeleton()
          this.cart.open()
        }
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id),
        )
        formData.append('sections_url', window.location.pathname)
        this.cart.setActiveElement(document.activeElement)
      }

      // Optimistic open, mirroring the cart drawer's own setLineItemSkeleton()
      // + open() above: assumes this add-to-cart is about to succeed rather
      // than waiting on the response, so the dialog's own slide-up animation
      // plays immediately on click instead of after a round trip. Its
      // cross-sell card already shows a loading skeleton while #loadProducts
      // fetches (see pdp-post-atc-modal.js), the same "shell now, contents
      // after" pattern the cart drawer's skeleton uses. Reverted below (see
      // the failure branch) on the rare response that isn't actually a
      // success. The added variant's own image isn't known synchronously —
      // the currently-displayed gallery image is close enough for this
      // instant-open header and gets replaced the next time the dialog opens
      // rather than ever being corrected in place.
      if (showPostAtcModal) {
        postAtcModal.open({
          title: this.productInfo.dataset.productTitle,
          size: this.productInfo.dataset.selectedSize,
          priceFormatted: this.productInfo.dataset.productPriceFormatted,
          image: this.productInfo.querySelector('.liquid-pdp__gallery-main img')?.src || '',
          productId: this.productInfo.dataset.productId,
        })
      }

      config.body = formData

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add`, config)
        const data = await response.json()

        if (!response.ok || data.status) {
          console.error('Cart add failed:', data)
          this.cart?.hideLineItemSkeleton()
          // Reverts the optimistic open() above — the add this modal assumed
          // had already succeeded actually failed.
          if (showPostAtcModal) postAtcModal.close()
          if (data.message) alert(data.message)
          return
        }

        if (this.productInfo) {
          this.resetQuantitySelector()
        }

        if (this.shouldSaveSizePreference())
          window.TcSizePreferences?.applyCartAddResponseSizes(data, this.isWomensProduct())

        const addedItem = Array.isArray(data?.items) ? data.items[0] : data
        reportLiveAddToCart({
          pageHandle: this.productInfo?.dataset.liveStream,
          productId: addedItem?.product_id,
          variantId: addedItem?.variant_id,
          productTitle: addedItem?.product_title,
          variantTitle: addedItem?.variant_title,
        })

        if (this.cart) {
          const openCart = !isClearance && !showPostAtcModal

          if (isClearance) {
            document.dispatchEvent(
              new CustomEvent('clearanceatcsuccess', {
                bubbles: true,
                detail: {
                  productTitle: this.productInfo.dataset.productTitle || '',
                  productId: addedItem?.product_id || this.productInfo.dataset.productId || null,
                  variantId: addedItem?.variant_id || addedItem?.id || null,
                  source: isClearancePageQuickAdd ? 'clearance-v3-quick-add' : 'product-form',
                },
              }),
            )
          }

          if (typeof data?.items === 'object' || data.sections === null) {
            // Multiple items added - trigger full cart refresh
            // Get the first item's variant ID for scrolling
            const addedVariantId = data?.items?.[0]?.variant_id || data?.items?.[0]?.id || null
            document.dispatchEvent(
              new CustomEvent('cartaddsuccess', {
                detail: {
                  openCart: openCart,
                  variantId: addedVariantId,
                },
              }),
            )
          } else {
            // Single item added - store variant ID for scrolling
            const addedVariantId = data?.variant_id || data?.id || null
            if (addedVariantId) {
              this.cart.dataset.scrollToVariantId = addedVariantId
            }
            CartPerformance.measure('add:paint-updated-sections', () => {
              this.cart.renderContents(data, openCart)
            })
            this.cart.classList.remove('cart-drawer__adding-to-cart')
          }
          // Multi-item path: the skeleton stays up until refreshCartDrawer() finishes (cart-drawer.js)

          // The deal modal (snippets/deal-quick-modal.liquid) closes itself the same way.
          const quickAddModal =
            this.closest('quick-modal, deal-quick-modal') || document.querySelector('quick-modal')
          if (quickAddModal) {
            if (this.productInfo.dataset.pageType !== 'bundle builder') {
              quickAddModal.close()
            }
          }

          let cartSource
          if (this.productInfo.dataset.pdpType === 'popup') {
            cartSource = 'Quick View'
            if (this.productInfo.dataset.pageType === 'bundle builder') {
              cartSource = 'AMSM'
            }
          } else {
            cartSource = packSize === 'Single' ? 'PDP Singles' : 'PDP Curated Pack'
          }

          window.dataLayer = window.dataLayer || []
          dataLayer.push({ ecommerce: null })
          window.dataLayer.push({
            event: 'add_to_cart',
            cart_source: cartSource,
            membership_status: this.productInfo.dataset.membershipStatus,
            ...window.intelligemsMeta,
            userId: this.productInfo.dataset.customerId || null,
            page_type: this.productInfo.dataset.pageType,
            color_pack: this.productInfo.dataset.colorPack,
            login_status: this.productInfo.dataset.loginStatus,
            pack_quantity: this.productInfo.dataset.packQuantity,
            pdp_type: this.productInfo.dataset.pdpType,
            ecommerce: {
              currency: this.productInfo.dataset.ecommerceCurrency,
              value: Number(this.productInfo.dataset.productPrice),
              items: [
                {
                  item_id: Number(this.productInfo.dataset.productId),
                  item_name: this.productInfo.dataset.productTitle,
                  coupon: '',
                  discount: Number(this.productInfo.dataset.productDiscount),
                  index: 1,
                  cart_source: cartSource,
                  item_brand: this.productInfo.dataset.productBrand,
                  item_category: this.productInfo.dataset.productCategory,
                  item_category2: this.productInfo.dataset.productCategory2,
                  item_category3: Number(this.productInfo.dataset.productCategory3),
                  item_category4: this.productInfo.dataset.productCategory4,
                  item_category5: this.productInfo.dataset.productCategory5,
                  item_list_id: '',
                  item_list_name: '',
                  item_variant: this.productInfo.dataset.colorPack,
                  price: Number(this.productInfo.dataset.productPrice),
                  quantity: packSize === 'Single' || isClearance ? Number(quantity) : 1,
                  style_number: this.productInfo.dataset.styleNumber
                    ? this.productInfo.dataset.styleNumber
                    : '',
                  sku_id: this.productInfo.dataset.sku ? this.productInfo.dataset.sku : '',
                  variant_id: this.productInfo.dataset.variantId
                    ? this.productInfo.dataset.variantId
                    : '',
                },
              ],
            },
          })
        }
      } catch (e) {
        console.error(e)
        this.cart?.hideLineItemSkeleton?.()
        postAtcModal?.close()
      } finally {
        this.submitButton.classList.remove('loading')
        this.submitButton.removeAttribute('aria-busy')
        if (this.cart && this.cart.classList.contains('is-empty'))
          this.cart.classList.remove('is-empty')
        if (!this.error) this.submitButton.removeAttribute('aria-disabled')
        this.submitSpinner?.classList.add('hidden')
        this.isSubmitting = false
        document.dispatchEvent(new CustomEvent('cartupdatesuccess'))
      }
    }

    getBundleSelections() {
      if (!this.productInfo) return []
      if (!Array.isArray(this.productInfo.bundleSelections)) {
        this.productInfo.bundleSelections = []
      }
      return this.productInfo.bundleSelections
    }

    renderBundleBuilderState() {
      if (!this.bundleBuilder || !this.productInfo) return

      const isBundleMode = this.productInfo.dataset.bundleMode === 'true'
      this.bundleBuilder.hidden = !isBundleMode
      if (!isBundleMode) return

      const bundleSelections = this.getBundleSelections()
      const bundleLimit = Number(this.productInfo.dataset.bundleMaxItems || 6)
      const remaining = Math.max(bundleLimit - bundleSelections.length, 0)

      if (this.bundleBuilderStatus) {
        this.bundleBuilderStatus.textContent = remaining
          ? `Add ${remaining} more product${remaining === 1 ? '' : 's'} to complete your bundle`
          : 'Bundle complete. Add it to cart when ready.'
      }

      this.bundleBuilderSlots.forEach((slot, index) => {
        const selection = bundleSelections[index]
        const slotText = slot.querySelector('.liquid-pdp__bundle-builder-slot-text')

        slot.classList.toggle('is-filled', Boolean(selection))
        slot.style.backgroundImage = ''

        if (slotText) {
          slotText.textContent = selection ? selection.color : 'Pick a variant'
        }
      })
    }

    /*
      Build line item properties so the cart drawer can render the singles
      that make up a custom pack. Identical (color + size) selections are
      grouped and a `_component_NN` property is emitted per unique single
      with `quantity|color|size|image_url`. The `_` prefix hides the
      properties from Shopify's default "additional details" UI in the
      drawer; cart-drawer.liquid reads them explicitly.
    */
    /*
    buildBundleComponentProperties(bundleSelections) {
      const singlesData = this.productInfo?.jsonData?.singles_data_json || []

      const grouped = bundleSelections.reduce((acc, sel) => {
        const key = String(sel.id)
        if (!acc[key]) acc[key] = { ...sel, quantity: 0 }
        acc[key].quantity += 1
        return acc
      }, {})

      const properties = {}
      Object.values(grouped).forEach(function buildProperty(comp, idx) {
        const single =
          (comp.handle && singlesData.find((p) => p.handle === comp.handle)) ||
          singlesData.find((p) => p.variants?.some((v) => v.id === comp.id))

        let image = ''
        const media = single?.media
        if (Array.isArray(media) && media.length) {
          const firstImage = media.find((m) => m.media_type === 'image') || media[0]
          if (firstImage?.src) {
            const sep = firstImage.src.includes('?') ? '&' : '?'
            image = `${firstImage.src}${sep}width=120`
          }
        }

        const num = String(idx + 1).padStart(2, '0')
        properties[`_component_${num}`] = [
          comp.quantity,
          comp.color || '',
          comp.title || '',
          image,
        ].join('|')
      })

      return properties
    }
    */

    async handleBundleSubmit() {
      if (!this.productInfo) return
      const bundleSelections = this.getBundleSelections()

      // ATC stays button-disabled until isBundleReady — slot count matches the
      // current pack-size AND no foreign-family singles (hasBundleFamilyMismatch)
      // AND every slot is in-stock. This is the cart-correctness guard; it's
      // also re-checked here in case submit is triggered programmatically.
      if (!this.productInfo.isBundleReady?.()) return

      const bundleInfo = _h7(
        Object.entries(
          bundleSelections.reduce((acc, item) => {
            const key = item.id
            acc[key] = (acc[key] || 0) + 1
            return acc
          }, {}),
        )
          .map(([id, quantity]) => `${id}b${quantity}`)
          .join('g')
      );

      // const componentProperties = this.buildBundleComponentProperties(bundleSelections)

      const bundleVariantId = Number(this.productInfo.dataset.bundleProductVariantId)
      if (!bundleVariantId) {
        throw new Error(
          `product-form.handleBundleSubmit: missing data-bundle-product-variant-id on product-info (handle=${this.productInfo.dataset.bundleProductHandle || 'unknown'})`,
        )
      }

      const items = [
        {
          id: bundleVariantId,
          quantity: 1,
          properties: {
            _bundleInfo: bundleInfo,
            ...(this.productInfo.dataset.liveStream
              ? { _live_stream: this.productInfo.dataset.liveStream }
              : {}),
            // ...componentProperties,
          },
        },
      ]

      // Mirror the regular ATC: when the insider-club upsell is checked,
      // append it as a second cart item so it gets added in the same call.
      const insiderClubUpsell = this.productInfo.querySelector('input[name="insider-club-upsell"]')
      if (insiderClubUpsell?.checked) {
        const insiderItem = {
          id: Number(insiderClubUpsell.value),
          quantity: 1,
        }
        if (insiderClubUpsell.dataset.sellingPlan) {
          insiderItem.selling_plan = Number(insiderClubUpsell.dataset.sellingPlan)
        }
        items.push(insiderItem)
      }

      // Mismatch sanity check: a selected single whose handle is absent from
      // the current family's singles_data_json (or a count vs pack-size drift)
      // means the parent and singles belong to different families — the
      // family-switch race producing a cart mismatch.
      const familySingles = this.productInfo.jsonData?.singles_data_json
      const familyHandles = Array.isArray(familySingles)
        ? familySingles.map((p) => p.handle)
        : []
      const hasForeignSingle = bundleSelections.some(
        (s) => s?.handle && familyHandles.length && !familyHandles.includes(s.handle),
      )
      const countMismatch = bundleSelections.length !== this.productInfo.bundleLimit
      if (hasForeignSingle || countMismatch) {
        console.warn(
          `[custom-pack ATC] MISMATCH — parent ${this.productInfo.dataset.bundleProductHandle || 'unknown'} vs ${bundleSelections.length} singles`,
        )
      }

      this.isSubmitting = true
      this.submitButton.setAttribute('aria-disabled', true)
      this.submitButton.setAttribute('aria-busy', 'true')
      this.submitButton.classList.add('loading')
      this.submitSpinner?.classList.remove('hidden')

      // Same optimistic open as the regular submit path (see onSubmitHandler):
      // a custom pack's add-to-cart is just as much an "added something" moment
      // worth the cross-sell, and its cartaddsuccess below is told not to open
      // the cart drawer over it.
      const postAtcModal = this.getEligiblePostAtcModal()
      if (postAtcModal) {
        postAtcModal.open({
          title: this.productInfo.dataset.productTitle,
          size: this.productInfo.dataset.selectedSize,
          priceFormatted: this.productInfo.dataset.productPriceFormatted,
          image: this.productInfo.querySelector('.liquid-pdp__gallery-main img')?.src || '',
          productId: this.productInfo.dataset.productId,
        })
      }

      // Open the drawer on a skeleton now; the refresh after cartaddsuccess clears it
      if (!postAtcModal && this.cart?.setLineItemSkeleton) {
        this.cart.setLineItemSkeleton()
        this.cart.open()
      }

      try {
        const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items }),
        })

        const data = await response.json()
        if (!response.ok || data.status) {
          console.error('Bundle add failed:', data)
          this.cart?.hideLineItemSkeleton?.()
          postAtcModal?.close()
          if (data.message) alert(data.message)
          return
        }

        if (this.shouldSaveSizePreference()) {
          window.TcSizePreferences?.applyCartAddResponseSizes(data, this.isWomensProduct())
          window.TcSizePreferences?.applyBundleSelectionSizes(bundleSelections, this.isWomensProduct())
        }

        const addedBundleItem = Array.isArray(data?.items) ? data.items[0] : data
        reportLiveAddToCart({
          pageHandle: this.productInfo?.dataset.liveStream,
          productId: addedBundleItem?.product_id,
          variantId: addedBundleItem?.variant_id,
          productTitle: addedBundleItem?.product_title,
          variantTitle: addedBundleItem?.variant_title,
        })

        // Intentionally NOT clearing bundleSelections here — the user wants
        // slots to stay populated after add-to-cart so they can quickly add
        // the same configuration again or tweak it.
        this.renderBundleBuilderState()
        this.productInfo.updateBundleModeUi()

        document.dispatchEvent(
          new CustomEvent('cartaddsuccess', {
            detail: {
              openCart: !postAtcModal,
              refreshCart: true,
              variantId: bundleVariantId,
            },
          }),
        )

        // Same as the regular add (after the cart opens): quick-add closes so the drawer is what's left.
        if (this.productInfo.dataset.pageType !== 'bundle builder') {
          this.closest('quick-modal, deal-quick-modal')?.close()
        }
      } catch (e) {
        console.error(e)
        this.cart?.hideLineItemSkeleton?.()
      } finally {
        this.submitButton.classList.remove('loading')
        this.submitButton.removeAttribute('aria-busy')
        this.submitButton.removeAttribute('aria-disabled')
        this.submitSpinner?.classList.add('hidden')
        this.isSubmitting = false
        document.dispatchEvent(new CustomEvent('cartupdatesuccess'))
      }
    }
  }
  customElements.define('product-form', ProductForm)
}
